import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ShoppingBag, Package, CreditCard, TicketPercent } from "lucide-react";

export function NusrifAnimatedLogo() {
  const ecommerceIcons = [ShoppingBag, Package, CreditCard, TicketPercent];
  const [iconIndex, setIconIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIconIndex((prev) => (prev + 1) % ecommerceIcons.length);
    }, 1200);
    return () => clearInterval(interval);
  }, []);

  const CurrentIcon = ecommerceIcons[iconIndex];

  return (
    <div className="flex items-center justify-center">
      <motion.svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 2400 2400"
        className="w-32 h-32"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, ease: "easeInOut" }}
      >
        <g>
          {/* Circle background */}
          <motion.path
            d="M2400 1200C2400 1862.88 1862.88 2400 1200 2400C537.122 2400 0 1862.88 0 1200C0 537.122 537.122 0 1200 0C1862.88 0 2400 537.122 2400 1200Z"
            fill="#1E4AA8"
          />
          <motion.g
            key="icon"
            initial={{ opacity: 0, rotate: -90, scale: 0.8 }}
            animate={{ opacity: 1, rotate: 0, scale: 1 }}
            exit={{ opacity: 0, rotate: 90, scale: 0.8 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            <foreignObject x="800" y="800" width="800" height="800">
              <div className="flex items-center justify-center w-full h-full text-white">
                <CurrentIcon size="100%" color="white" />
              </div>
            </foreignObject>
          </motion.g>
        </g>
      </motion.svg>
    </div>
  );
}
